module.exports = __webpack_public_path__ + "static/media/19.8e7837e3.jpg";